module.exports = __webpack_public_path__ + "static/media/IconFlagInactive.e66fe608.svg";